import React, { useEffect, useState } from "react";
import styles from './LandingPage.module.css';

const Banner = (props) => {

    return (
        <section className={styles.features}>

            <div className={styles.featuresRow}>

                {/* LEFT (20%) */}
                <div className={`${styles.landingContainer} ${styles.featuresLeft}`}>
                    <h2>
                        EVERYTHING <br />
                        <span className={styles.colorText}>CREATORS NEED</span>
                    </h2>
                </div>

                {/* RIGHT (80%) */}
                <div className={styles.featuresRight}>

                    <div className={styles.featuresScroll} >

                        <div className={styles.featuresCard}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/feature1.png" />
                            <div className={styles.text}>Creator <br /> Dashboard</div>
                        </div>

                        <div className={styles.featuresCard}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/feature2.png" />
                            <div className={styles.text}>Easy <br />Withdrawals</div>
                        </div>

                        <div className={styles.featuresCard}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/feature3.png" />
                            <div className={styles.text}>Exclusive<br /> Content</div>
                        </div>

                        <div className={styles.featuresCard}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/feature4.png" />
                            <div className={styles.text}>Private<br /> Community</div>
                        </div>

                        <div className={styles.featuresCard}>
                            <img src="https://admin.rebeltv.me/rebel-homepage-assets/feature5.png" />
                            <div className={styles.text}>Live<br /> Streaming</div>
                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
};

export default Banner;